import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LeaveTrendChart = ({ data, selectedTypes }) => {
  const typeConfig = {
    annual: { color: '#C41E3A', name: 'Annual Leave' },
    sick: { color: '#E53E3E', name: 'Sick Leave' },
    maternity: { color: '#FFD700', name: 'Maternity Leave' },
    longService: { color: '#059669', name: 'Long Service Leave' }
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-md shadow-lg p-3">
          <p className="font-body font-semibold text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <div className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-full" 
                  style={{ backgroundColor: entry?.color }}
                />
                <span className="caption text-xs text-muted-foreground">{entry?.name}</span>
              </div>
              <span className="data-text text-sm font-medium text-foreground">
                {entry?.value} days
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground">
          Leave Utilization Trends
        </h3>
        <div className="caption text-xs md:text-sm text-muted-foreground">
          Rolling 12 Months
        </div>
      </div>
      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Leave Utilization Trends Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-data)' }}
              label={{ value: 'Days', angle: -90, position: 'insideLeft', style: { fill: 'var(--color-muted-foreground)' } }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            {selectedTypes?.includes('annual') && (
              <Line 
                type="monotone" 
                dataKey="annual" 
                stroke={typeConfig?.annual?.color} 
                strokeWidth={2}
                name={typeConfig?.annual?.name}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            )}
            {selectedTypes?.includes('sick') && (
              <Line 
                type="monotone" 
                dataKey="sick" 
                stroke={typeConfig?.sick?.color} 
                strokeWidth={2}
                name={typeConfig?.sick?.name}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            )}
            {selectedTypes?.includes('maternity') && (
              <Line 
                type="monotone" 
                dataKey="maternity" 
                stroke={typeConfig?.maternity?.color} 
                strokeWidth={2}
                name={typeConfig?.maternity?.name}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            )}
            {selectedTypes?.includes('longService') && (
              <Line 
                type="monotone" 
                dataKey="longService" 
                stroke={typeConfig?.longService?.color} 
                strokeWidth={2}
                name={typeConfig?.longService?.name}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LeaveTrendChart;